import { InlineResponse20012, InlineResponse20012FromJSON } from '../models/InlineResponse20012';
import * as runtime from '../runtime';

export interface NotificationsReadBody {
  ids: number[]
}

export interface NotificationsRequestParams {
  type?: string,
  limit?: number,
  offset?: number
}

export function NotificationsReadBodyToJSON(value?: NotificationsReadBody | null): any {
  if (value === undefined) {
      return undefined;
  }
  if (value === null) {
      return null;
  }
  return {
      'ids': value.ids
  };
}

export class AmoNotificationsApi extends runtime.BaseAPI {

  async getNotificationsRaw(requestParameters?: NotificationsRequestParams): Promise<runtime.ApiResponse<InlineResponse20012>> {

    const headerParameters: runtime.HTTPHeaders = {};

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters?.type) {
      queryParameters['type'] = requestParameters.type
    }

    if (requestParameters?.limit) {
      queryParameters['limit'] = requestParameters.limit
    }

    if (requestParameters?.offset) {
      queryParameters['offset'] = requestParameters.offset
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
    }

    const response = await this.request({
      path: `/profile/v1/notification`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters
    });

    return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse20012FromJSON(jsonValue));
  }

  async getNotifications(requestParameters?: NotificationsRequestParams): Promise<InlineResponse20012> {
    const response = await this.getNotificationsRaw(requestParameters);
    return await response.value();
  }

  async readNotificationsRaw(requestParameters: NotificationsReadBody): Promise<runtime.ApiResponse<InlineResponse20012>> {

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
    }

    const response = await this.request({
      path: `/profile/v1/notification/read`,
      method: 'POST',
      headers: headerParameters,
      body: NotificationsReadBodyToJSON(requestParameters),
    });

    return new runtime.JSONApiResponse(response);
  }

  async readNotifications(requestParameters: NotificationsReadBody): Promise<InlineResponse20012> {
    const response = await this.readNotificationsRaw(requestParameters);
    return await response.value();
  }
}